import React from 'react';
import {AtomicBlockUtils, convertFromRaw, convertToRaw, Editor, EditorState, genKey, RichUtils} from 'draft-js'


class PageBlock extends React.Component {
    render() {
        const {contentState, block} = this.props;

        const entity = contentState.getEntity(block.getEntityAt(0));
        if (entity && entity.type === 'pageBreak') {
            return (
                <div className="evt-summary-editor-page-break">我是分页符（建议260字/页）</div>
            )
        }
    }
}


const ckBlockRenderer = (block) => {
    if (block.getType() === 'atomic') {
        return {
            component: PageBlock,
            editable: false,
        };
    }
    return null;
}

const PAGE_BREAK_KEYWORD = "##PageBreak##";

const draftToEvtSummaryRaw = (editorContent) => {
    const rawData = [];
    if (editorContent) {
        const {blocks, entityMap} = editorContent;
        if (blocks && blocks.length > 0) {
            blocks.forEach((block) => {
                if (block.type === 'atomic') {
                    rawData.push(PAGE_BREAK_KEYWORD)
                } else {
                    rawData.push(block.text)
                }
            })
        }
    }
    return rawData.join("\n");

}

const evtSummaryRawToDraft = (raw) => {
    if (raw) {
        const rawData = raw.split("\n");
        if (rawData.length > 0) {

            let entityMap = {};
            let blocks = [];

            var index = 0;
            rawData.forEach((text, ii) => {
                const isAtomicBlock = text == PAGE_BREAK_KEYWORD;
                if (isAtomicBlock) {
                    entityMap[index + ""] = {
                        type: "pageBreak",
                        mutability: "IMMUTABLE",
                        data: {}
                    }
                    blocks.push({
                        key: genKey(),
                        text: " ",
                        type: "atomic",
                        depth: 0,
                        inlineStyleRanges: [],
                        entityRanges: [{
                            offset: 0,
                            length: 1,
                            key: index
                        }],
                        data: {}
                    })
                    index++;

                } else {
                    blocks.push({
                        key: genKey(),
                        text: text,
                        type: "unstyled",
                        depth: 0,
                        inlineStyleRanges: [],
                        entityRanges: [],
                        data: {}
                    })
                }

            })

            return {
                blocks: blocks,
                entityMap: entityMap
            }

        }
    }
    return null;
}


class EvtSummaryEditor extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            inputEditorState: this.props.value ? EditorState.createWithContent(convertFromRaw(evtSummaryRawToDraft(this.props.value))) : EditorState.createEmpty(),
        };
        this.editor = null;
    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidMount() {

    }

    handleKeyCommand = (command) => {
        console.log(command)
        const {inputEditorState} = this.state;
        const newState = RichUtils.handleKeyCommand(inputEditorState, command);
        if (newState) {
            this.onChange(newState);
            return true;
        }
        return false;
    }

    focus = (e) => {
        this.editor.focus();
    }

    undo = () => {
        const {inputEditorState} = this.state;
        this.onChange(
            EditorState.undo(inputEditorState)
        );
    }
    redo = () => {
        const {inputEditorState} = this.state;
        this.onChange(
            EditorState.redo(inputEditorState)
        );
    };
    addPageBreak = () => {
        const {inputEditorState} = this.state;

        const contentState = inputEditorState.getCurrentContent();
        const contentStateWithEntity = contentState.createEntity('pageBreak', 'IMMUTABLE', {});
        const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        const newEditorState = EditorState.set(inputEditorState, {currentContent: contentStateWithEntity});
        this.onChange(
            AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, ' ')
        )
    }


    onChange = (editorState) => {
        this.setState({inputEditorState: editorState});
        this.props.onChange(draftToEvtSummaryRaw(convertToRaw(editorState.getCurrentContent())));
    }

    render() {


        return (
            <div className="evt-summary-editor-root">
                <div className="evt-summary-editor-control">
                    <div className="evt-summary-editor-controls" onMouseDown={(e) => {
                        e.preventDefault();
                        this.focus
                    }}>
                        <span className="evt-summary-editor-style-button" onClick={this.undo}>撤销</span>
                        <span className="evt-summary-editor-style-button" onClick={this.redo}>重做</span>
                        <span className="ant-divider" style={{margin: "0 16px 0 0"}}/>
                        <span className="evt-summary-editor-style-button" onClick={this.addPageBreak}>分页符</span>
                    </div>
                </div>
                <div className="evt-summary-editor" onClick={this.focus}>
                    <Editor
                        placeholder={this.props.placeholder}
                        ref={(editor) => this.editor = editor}
                        editorState={this.state.inputEditorState}
                        onChange={this.onChange}
                        blockRendererFn={ckBlockRenderer}
                        handleKeyCommand={this.handleKeyCommand}
                        stripPastedStyles={false}
                    />
                </div>
            </div>
        );
    }
}


EvtSummaryEditor.contextTypes = {};

EvtSummaryEditor.defaultProps = {
    size: "default",
    title: "",
    collapsed: true,
    onCollapse: () => null,
    onChange: (raw) => null,
};

EvtSummaryEditor.propTypes = {}


export default EvtSummaryEditor;


// WEBPACK FOOTER //
// ./src/components/EvtSummaryEditor.js